import { UrlContext } from "../../contexts/UrlContext";
import React, { useState, useEffect, useContext } from "react";
import { FaEye } from "react-icons/fa";
import Swal from "sweetalert2";

const PageViewCounter = ({ project }) => {
  const { API_URL } = useContext(UrlContext);
  // State to store the total number of visits
  const [visitCount, setVisitCount] = useState(0);
  // State to store visits breakdown by country

  // State to indicate whether data is being loaded
  const [loading, setLoading] = useState(true);
  const [showHoverTooltip, setShowHoverTooltip] = useState(false);
  // State to control the visibility of the context (right-click) tooltip (detailed breakdown)
  const [showContextTooltip, setShowContextTooltip] = useState(false);

  useEffect(() => {
    const fetchAnalyticsData = async () => {
      try {
        const response = await fetch(`${API_URL}client-views/${project}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // Expected response format:
        // {
        //   visitCount: number,
        //   visitsByCountry: { [countryName: string]: number }
        // }
        setVisitCount(data.count || 0);
      } catch (error) {
        console.error("Error fetching analytics data:", error);
       
      } finally {
        setLoading(false);
      }
    };

    fetchAnalyticsData();
  }, [project]);
  const tooltipStyle = {
    position: "absolute",
    backgroundColor: "#333",
    color: "#fff",
    padding: "4px 8px",
    borderRadius: "4px",
    top: "100%",
    left: "50%",
    transform: "translateX(-50%)",
    whiteSpace: "nowrap",
    fontSize: "12px",
    opacity: 1,
    pointerEvents: "none",
    zIndex: 999999, // Very high to stay on top
    marginTop: "6px",
    transition: "opacity 0.2s ease-in-out",
  };

  return (
    <div
      style={{ position: "relative", display: "inline-block" }}
      onMouseEnter={() => setShowHoverTooltip(true)}
      onMouseLeave={() => {
        setShowHoverTooltip(false);
        setShowContextTooltip(false);
      }}
      onClick={(e) => {
        e.preventDefault(); // Prevent default right-click menu
        setShowContextTooltip(true);
        setShowHoverTooltip(false);
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          marginLeft: "10px",
        }}
      >
        <FaEye style={{ marginRight: 4 }} />
        <span>{loading ? "..." : visitCount}</span>
      </div>
      {/* {showContextTooltip ? (
        <div style={tooltipStyle}>
          {entries.length > 0 ? (
            entries.map(([country, count]) => (
              <div key={country}>
                {country}: {count}
              </div>
            ))
          ) : (
            <div>No country data available</div>
          )}
        </div>
      ) : (
        showHoverTooltip && <div style={tooltipStyle} title="test">Client visits</div>
      )} */}
    </div>
  );
};

export default PageViewCounter;
